import { FC } from 'react'

import { Select } from '@hhgtech/hhg-components/mantine'
import { rem } from '@mantine/core'
import { SelectProps } from '@mantine/core/lib/Select'
import { useIntl } from 'react-intl'

export type ClinicLocatorSidebarLocationProps = SelectProps
export const ClinicLocatorSidebarLocation: FC<ClinicLocatorSidebarLocationProps> = (
  props,
) => {
  const { data = [], defaultValue = '', value, onChange, ...restProps } = props
  const { formatMessage: f } = useIntl()

  if (!data || !data?.length) {
    return null
  }

  return (
    <Select
      defaultValue={defaultValue}
      {...restProps}
      data={[
        { label: f({ id: 'clinicLocator.filterAll' }), value: '' },
        ...data,
      ]}
      filter={() => true}
      value={value}
      onChange={onChange}
      // dropdownComponent={({ children }: any) => {
      //   return (
      //     <ScrollArea scrollbarSize={8} miw="100%">
      //       {children}
      //     </ScrollArea>
      //   )
      // }}
      styles={() => ({
        root: {
          lineHeight: 1,
        },
        input: {
          maxWidth: rem(120),
          border: 'none',
          paddingLeft: 0,
          paddingRight: rem(20),
          backgroundColor: 'transparent',
          outline: 'none !important',
          boxShadow: 'none !important',
          '&:not(.mantine-Textarea-input)': {
            height: 'auto !important',
          },
          fontSize: rem(14),
          lineHeight: 1.5,
        },
        dropdown: {
          minWidth: rem(150),
        },
        rightSection: {
          width: rem(16),
        },
      })}
    />
  )
}
